<template>
  <div v-if="loading" class="content">
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div v-else class="content" style="background-color: '#EEEEEE'">
    <div class="md-layout">
      <period-selector
        title="Parâmetros de Seleção de Dados"
        sub-title="Selecione as opções de busca de dados (período máximo 3 meses)"
        validate-on-select
        :default-start="DEFAULT_START"
        :default-end="DEFAULT_END"
        :max-duration="MAX_DURATION"
        :show-loading="loading"
        @onClickFetch="fillData"
        @dataChanged="intervalChanged"
      />

      <md-card v-if="showFilters">
        <md-card-header :data-background-color="dataBackgroundColor">
          <h4 class="title">Parâmetros de Análise</h4>
          <p class="category">Selecione as opções da análise</p>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div
              v-if="apexSeries.length == 0"
              class="md-layout-item md-small-size-50 md-size-50"
            >
              <md-field>
                <label for="movie">Demonstrativo</label>
                <md-select
                  id="demonstrativeSelection"
                  v-model="demonstrativeSelection"
                  name="demonstrativeSelection"
                >
                  <md-option value="0"> Data: Ano </md-option>
                  <md-option value="1"> Data: Mês </md-option>
                  <md-option value="2"> Data: Dia </md-option>
                  <md-option value="3"> Modalidade </md-option>
                  <md-option value="4"> Categoria </md-option>
                  <md-option value="5"> Disciplina </md-option>
                  <md-option value="6"> Equipamento </md-option>
                  <md-option value="7"> Site </md-option>
                </md-select>
              </md-field>
            </div>

            <div
              v-if="apexSeries.length > 0"
              class="md-layout-item md-small-size-50 md-size-50"
            >
              <md-field>
                <label for="movie">Demonstrativo</label>
                <md-select
                  id="demonstrativeSelection"
                  v-model="demonstrativeSelection"
                  name="demonstrativeSelection"
                  disabled
                >
                  <md-option value="0"> Data: Ano </md-option>
                  <md-option value="1"> Data: Mês </md-option>
                  <md-option value="2"> Data: Dia </md-option>
                  <md-option value="3"> Modalidade </md-option>
                  <md-option value="4"> Categoria </md-option>
                  <md-option value="5"> Disciplina </md-option>
                  <md-option value="6"> Equipamento </md-option>
                </md-select>
              </md-field>
            </div>

            <div
              v-if="apexSeries.length == 0"
              class="md-layout-item md-small-size-50 md-size-50"
            >
              <md-field>
                <label for="movie">Estratificação</label>
                <md-select
                  id="stratificationSelection"
                  v-model="stratificationSelection"
                  name="stratificationSelection"
                >
                  <md-option value="3"> Modalidade </md-option>
                  <md-option value="4"> Categoria </md-option>
                  <md-option value="5"> Disciplina </md-option>
                  <md-option value="6"> Equipamento </md-option>
                </md-select>
              </md-field>
            </div>

            <div
              v-if="apexSeries.length > 0"
              class="md-layout-item md-small-size-50 md-size-50"
            >
              <md-field>
                <label for="movie">Estratificação</label>
                <md-select
                  id="stratificationSelection"
                  v-model="stratificationSelection"
                  name="stratificationSelection"
                  disabled
                >
                  <md-option value="3"> Modalidade </md-option>
                  <md-option value="4"> Categoria </md-option>
                  <md-option value="5"> Disciplina </md-option>
                  <md-option value="6"> Equipamento </md-option>
                </md-select>
              </md-field>
            </div>

            <div
              v-if="demonstrativeSelection != ''"
              class="md-layout-item md-small-size-100 md-size-50"
            >
              <md-subheader>Filtro de Demonstrativo</md-subheader>
              <md-list md-expand-single="true">
                <v-select
                  v-model="demonstrativeFilterSelection"
                  label="name"
                  :options="demonstrativeFilterOptions"
                  taggable
                  multiple
                />
              </md-list>
            </div>

            <div
              v-if="stratificationSelection != ''"
              class="md-layout-item md-small-size-100 md-size-50"
            >
              <md-subheader>Modalidades</md-subheader>
              <md-list md-expand-single="true">
                <v-select
                  v-model="stratificationFilterSelection"
                  label="name"
                  :options="stratificationFilterOptions"
                  taggable
                  multiple
                />
              </md-list>
            </div>

            <div
              v-if="apexSeries.length == 0"
              class="md-layout-item md-small-size-50 md-size-50"
            >
              <md-field>
                <label for="movie">Tipo de Gráfico</label>
                <md-select
                  id="chartSelection"
                  v-model="chartSelection"
                  name="chartSelection"
                >
                  <md-option v-if="stratificationSelection == ''" value="0">
                    Pizza
                  </md-option>
                  <md-option v-if="stratificationSelection == ''" value="1">
                    Coluna
                  </md-option>
                  <md-option v-if="stratificationSelection != ''" value="2">
                    Coluna Agrupada
                  </md-option>
                  <md-option v-if="stratificationSelection != ''" value="3">
                    Coluna Empilhada
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <div
              v-if="apexSeries.length > 0"
              class="md-layout-item md-small-size-50 md-size-50"
            >
              <md-field>
                <label for="movie">Tipo de Gráfico</label>
                <md-select
                  id="chartSelection"
                  v-model="chartSelection"
                  name="chartSelection"
                  disabled
                >
                  <md-option v-if="stratificationSelection == ''" value="0">
                    Pizza
                  </md-option>
                  <md-option v-if="stratificationSelection == ''" value="1">
                    Coluna
                  </md-option>
                  <md-option v-if="stratificationSelection != ''" value="2">
                    Coluna Agrupada
                  </md-option>
                  <md-option v-if="stratificationSelection != ''" value="3">
                    Coluna Empilhada
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                v-if="demonstrativeSelection != ''"
                class="md-raised md-success"
                @click="createChart('0')"
              >
                QUANTITATIVO
              </md-button>
              <md-button
                v-if="demonstrativeSelection != ''"
                class="md-raised md-success"
                @click="createChart('1')"
              >
                HORAS
              </md-button>
              <md-button
                v-if="demonstrativeSelection != ''"
                class="md-raised md-success"
                @click="createChart('2')"
              >
                CUSTO
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <div
        v-if="showChart"
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card style="text-align: center">
          <md-card-header data-background-color="green">
            <h4 class="title">Relatório Dinâmico</h4>
          </md-card-header>
          <div id="chart" style="text-align: center; top: 10%; left: 10%">
            <apexcharts
              :options="apexOptions"
              :series="apexSeries"
              width="80%"
            />
          </div>
        </md-card>
      </div>
    </div>

    <md-card>
      <md-card-header data-background-color="green">
        <h4 class="title">Detalhamento</h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100">
            <md-table v-model="this.apexSeries">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Estratificação">
                  {{ item.name }}
                </md-table-cell>
                <md-table-cell
                  v-for="(cat, index) in apexOptions.labels"
                  :key="cat"
                  :md-label="cat"
                >
                  {{ item.data[index] }}
                </md-table-cell>

                <!-- <md-table-cell md-label="Estratificação">{{ item.name }}</md-table-cell> -->
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { DateTime, Duration } from "luxon";
import { jsPDF } from "jspdf";
import VueApexCharts from "vue-apexcharts";

import { userService } from "../_services";
import { getUserSession } from "../_services/localstorage";

import PeriodSelector from "@/components/PeriodSelector.vue";
import { DateTimeFormats } from "@/util/datetime.formats";

export default {
  components: {
    PeriodSelector,
    apexcharts: VueApexCharts,
  },
  data() {
    const MAX_DURATION = Duration.fromObject({ months: 3 });

    return {
      loading: false,
      dataBackgroundColor: "green",

      tickets: [],
      ticketList: [],
      totalTickets: 0,
      searchingTickets: false,
      showFilters: false,
      showChart: false,
      techCatList: [],
      techList: [],
      equipments: [],
      modalityFilterOptions: [],
      modalityFilterSelection: [],
      categoryFilterOptions: [],
      categoryFilterSelection: [],
      systemFilterOptions: [],
      systemFilterSelection: [],
      equipmentFilterOptions: [],
      equipmentFilterSelection: [],

      // Analise
      demonstrativeSelection: "",
      stratificationSelection: "",
      chartSelection: "1",

      demonstrativeSelectionOld: "",
      stratificationSelectionOld: "",
      chartSelectionOld: "",

      demonstrativeFilterOptions: [],
      demonstrativeFilterSelection: [],

      stratificationFilterOptions: [],
      stratificationFilterSelection: [],

      yearsOptions: [],
      monthsOptions: [],
      daysOptions: [],
      modalitiesOptions: [],
      categoriesOptions: [],
      systemOptions: [],
      equipmentOptions: [],

      // Chart

      apexOptions: {
        chart: {
          type: "bar",
          autoSelected: "zoom",
          // type: 'pie',
          height: 350,
          width: "80%",
          // stacked: true,
          toolbar: {
            show: true,
          },
        },
        labels: [],
        plotOptions: {},
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val;
            },
          },
        },

        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          tools: { download: false },
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        theme: {
          palette: "palette2",
        },
        fill: {
          opacity: 1,
        },
        colors: [
          "#3366cc",
          "#dc3912",
          "#ff9900",
          "#109618",
          "#990099",
          "#0099c6",
          "#dd4477",
          "#66aa00",
          "#b82e2e",
          "#316395",
          "#3366cc",
          "#994499",
          "#22aa99",
          "#aaaa11",
          "#6633cc",
          "#e67300",
          "#8b0707",
          "#651067",
          "#329262",
          "#5574a6",
          "#3b3eac",
          "#b77322",
          "#16d620",
          "#b91383",
          "#f4359e",
          "#9c5935",
          "#a9c413",
          "#2a778d",
          "#668d1c",
          "#bea413",
          "#0c5922",
          "#743411",
        ],
        legend: {
          position: "bottom",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },

      apexSeries: [],

      stackedPlotOptions: {
        bar: {
          horizontal: false,
        },
        dataLabels: {
          position: "bottom",
          enabled: true,
        },
      },

      piePlotOptions: {
        pie: {
          customScale: 1,
          offsetX: 0,
          offsetY: 0,
          expandOnClick: true,
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 0,
          },
          donut: {
            size: "65%",
            background: "transparent",
            labels: {
              show: false,
              name: {
                show: true,
                fontSize: "22px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 600,
                color: undefined,
                offsetY: -10,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 400,
                color: undefined,
                offsetY: 16,
                formatter: function (val) {
                  return val;
                },
              },
              total: {
                show: false,
                showAlways: false,
                label: "Total",
                fontSize: "22px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 600,
                color: "#373d3f",
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                },
              },
            },
          },
        },
      },

      DEFAULT_START: DateTime
        .now()
        .minus(MAX_DURATION)
        .startOf("day")
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME),

      DEFAULT_END: DateTime
        .now()
        .endOf("day")
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME),

      MAX_DURATION,
    };
  },
  created() {
    this.loading = true;
    this.user = getUserSession();
    this.glpiActiveEntity = this.user.activeentity;
    // console.log(this.glpiActiveEntity)
    // this.loading=false;
    // console.log("search1");
    // console.log(this.user )
    this.modalityFilterSelection = this.user.modalityOptions;
    this.modalityFilterOptions = this.user.modalityOptions;

    this.categoryFilterOptions = this.user.categoryOptions;
    this.categoryFilterSelection = this.user.categoryOptions;

    this.systemFilterOptions = this.user.equipmentModels;
    this.systemFilterSelection = this.user.equipmentModels;

    userService.getAllActives(this.user.token).then((glpiActives) => {
      // console.log(searchResult)
      this.equipments = glpiActives;
      this.equipmentFilterOptions = glpiActives;
      this.equipmentFilterSelection = glpiActives;
      // console.log(this.equipments)
    });

    // Get User Categories
    userService.getUserCategoriesCost().then((searchResult) => {
      // console.log(searchResult)
      this.techCatList = searchResult;

      // Get User List
      userService.getUserList(this.user.token).then((searchResult) => {
        // console.log(searchResult)

        // Add User Cost
        for (var i = 0; i < searchResult.length; i++) {
          for (var j = 0; j < this.techCatList.length; j++) {
            if (searchResult[i].title == this.techCatList[j].name) {
              // console.log(searchResult[i].title)
              searchResult[i].cost = this.techCatList[j].cost;
            }
          }
        }
        this.techList = searchResult;
        // console.log(this.techList)
      });
    });

    var now = new Date();

    // Get one month before
    var past = new Date();
    if (past.getMonth() != 0) {
      past.setMonth(past.getMonth() - 1);
    } else {
      past.setMonth(11);
      past.setYear(past.getYear() - 1);
    }

    // console.log(this.selectionData)
    this.selectionData = {
      begin_date: this.dataInputFormatada(past.toISOString()),
      end_date: this.dataInputFormatada(new Date().toISOString()),
    };
    // console.log(this.selectionData)

    this.PastMonth = now.getMonth() - 1;
    if (this.PastMonth > 0) {
      this.PastYear = now.getFullYear();
    } else {
      this.PastMonth = 11;
      this.PastYear = now.getFullYear() - 1;
    }

    this.totalLYTickets = [];
    this.countRespose = 0;
    this.processTicket = false;

    this.checkSite();
    // this.loadData();
    this.timer = setInterval(this.checkSite, 1000);

    this.loading = false;
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    intervalChanged(filter) {
      /** @type {{ start: DateTime, end: DateTime }} */
      this.filter = {
        start: DateTime.fromFormat(filter.start, DateTimeFormats.HTML_INPUT_DATETIME),
        end: DateTime.fromFormat(filter.end, DateTimeFormats.HTML_INPUT_DATETIME),
      };
    },
    loadData: function () {},
    getSelected: function (ticket, funct) {
      var result;

      switch (funct) {
        case "0":
          // Selected by Year
          result = ticket.year;
          break;
        case "1":
          // Selected by Month
          result = ticket.month;
          break;
        case "2":
          // Selected by Day
          result = ticket.day;
          break;
        case "3":
          // Selected by Modality
          result = ticket.modality;
          break;
        case "4":
          // Selected by Category
          result = ticket.category;
          break;
        case "5":
          // Selected by System
          result = ticket.equipment_type;
          break;
        case "6":
          // Selected by Equipment
          result = ticket.equipment;
          break;
        case "7":
          // Selected by Equipment
          result = ticket.entity;
          break;
        default:
          // code block
          result = "";
      }
      return result;
    },
    createChart: function (option) {
      // ####### Calculating #########
      var swap = [],
        disctinct = [],
        series = [],
        seriesx = [];

      if (this.tickets != null) {
        this.showChart = false;

        seriesx = this.demonstrativeFilterSelection;
        swap = this.stratificationFilterSelection;

        if (swap.length == 0) {
          swap.push({
            name: "Geral",
            id: 0,
          });
        }

        // Create Y Series
        for (var j = 0; j < swap.length; j++) {
          series.push(Array(seriesx.length).fill(0));
        }

        // Completing Chart X series
        this.apexOptions.xaxis.categories = [];
        this.apexOptions.labels = [];
        for (var i = 0; i < seriesx.length; i++) {
          this.apexOptions.xaxis.categories.push(seriesx[i].name);
          this.apexOptions.labels.push(seriesx[i].name);
        }

        // console.log(series)
        // console.log(swap)
        // console.log(seriesx)

        // Calculating all Categories by Date
        var date, position;
        for (var i = 0; i < this.tickets.length; i++) {
          // Finding the correct position on series
          for (var j = 0; j < seriesx.length; j++) {
            if (
              seriesx[j].name ==
              this.getSelected(this.tickets[i], this.demonstrativeSelection)
            ) {
              position = j;
            }
          }

          // Complete series based on Modality and Date
          for (var k = 0; k < swap.length; k++) {
            if (
              swap[k].name ==
                this.getSelected(
                  this.tickets[i],
                  this.stratificationSelection,
                ) ||
              swap[k].name == "Geral"
            ) {
              switch (option) {
                case "0":
                  // Total Tickets
                  series[k][position] = series[k][position] + 1;
                  break;
                case "1":
                  // Total Hours
                  series[k][position] =
                    series[k][position] + this.tickets[i].hours;
                  break;
                case "2":
                  // Total Cost
                  series[k][position] =
                    series[k][position] + this.tickets[i].totalcost;
                  break;

                default:
                  // code block
                  series[k][position] = series[k][position] + 1;
              }
            }
          }
        }
        // console.log(series)

        // Parse the series on the Chart Model
        this.apexSeries = [];

        if (this.chartSelection == "0") {
          this.apexSeries = series[0];
          this.apexOptions.plotOptions = this.piePlotOptions;
          this.apexOptions.chart.type = "pie";
        } else {
          this.apexOptions.plotOptions = this.stackedPlotOptions;
          this.apexOptions.chart.type = "bar";

          this.apexOptions.chart.stacked = true;
          if (this.chartSelection == "2") {
            this.apexOptions.chart.stacked = false;
          }

          for (var j = 0; j < swap.length; j++) {
            this.apexSeries.push({
              name: swap[j].name,
              data: series[j],
            });
          }
        }

        // console.log(this.apexSeries)

        this.showChart = true;
      }
    },
    dataInputFormatada: function (date) {
      var data = new Date(date);
      var dia = data.getDate().toString();
      var diaF = dia.length == 1 ? "0" + dia : dia;
      var mes = (data.getMonth() + 1).toString(); //+1 pois no getMonth Janeiro começa com zero.
      var mesF = mes.length == 1 ? "0" + mes : mes;
      var anoF = data.getFullYear();
      var hora = data.getHours().toString();
      var horaF = hora.length == 1 ? "0" + hora : hora;
      var minutos = data.getMinutes().toString();
      var minutosF = minutos.length == 1 ? "0" + minutos : minutos;
      return (
        anoF + "-" + mesF + "-" + diaF + "T" + horaF + ":" + minutosF + ":00"
      );
    },
    listFormatada: function (items) {
      var list = [];
      for (var j = 0; j < items.length; j++) {
        list.push({
          id: j,
          name: items[j],
        });
      }

      return list;
    },
    printPDF: function (count) {
      var ticketBody = this.ticketList[count].response;
      var ticketID = this.ticketList[count].id;
      var totalTickets = this.ticketList.length;

      var doc = new jsPDF("p", "pt", [1.17 * 595.28, 1.17 * 841.89]);
      var elementHandler = {
        "#ignorePDF": function (element, renderer) {
          return true;
        },
      };
      var source = ticketBody.substring(
        ticketBody.search("<table"),
        ticketBody.search("</body>"),
      );

      doc.html(source, {
        x: 3,
        y: 3,
        callback: function (doc) {
          doc.save("OS - " + ticketID);
          count = count + 1;
          if (count < totalTickets) {
            setTimeout(() => {
              this.printPDF(count);
            }, 1000);
          }
        },
      });
    },

    fillData: function () {
      this.searchingTickets = true;
      userService
        .searchTicketsByStatus(
          this.user.token,
          "all",
          1,
          this.filter.start.toFormat("dd/MM/yyyy+HH:mm"),
          this.filter.end.toFormat("dd/MM/yyyy+HH:mm"),
        )
        .then((searchResult) => {
          // Check total pages

          var pages = searchResult.totalTickets / 1000 + 1;
          this.totalTickets = searchResult.totalTickets;
          // console.log(pages)
          // Grep all tickets by 1000 at each time
          for (var i = 1; i <= pages; i++) {
            userService
              .searchTicketsInfo(
                this.user.token,
                "all",
                i,
                this.filter.start.toFormat("dd/MM/yyyy+HH:mm"),
                this.filter.end.toFormat("dd/MM/yyyy+HH:mm"),
              )
              .then((searchResult) => {
                // Save tickets to export
                var list = searchResult.list;
                for (var j = 0; j < list.length; j++) {
                  this.tickets.push(searchResult.list[j]);
                }
                // console.log(this.tickets)
              });
          }
        });
    },

    cancelAutoUpdate: function () {
      clearInterval(this.timer);
    },
    strip: function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },
    checkSite: function () {
      this.checkTicketList();

      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      // Check demonstrativeSelection

      this.checkDemonstrativeSelection();
    },
    checkDemonstrativeSelection: function () {
      if (this.demonstrativeSelection != this.demonstrativeSelectionOld) {
        // console.log("Check Demonstrative Selection = "+this.demonstrativeSelection )

        switch (this.demonstrativeSelection) {
          case "0":
            // Selected by Year
            this.demonstrativeFilterOptions = this.yearsOptions;
            this.demonstrativeFilterSelection = this.yearsOptions;
            // console.log(this.demonstrativeFilterOptions)
            break;
          case "1":
            // Selected by Month
            this.demonstrativeFilterOptions = this.monthsOptions;
            this.demonstrativeFilterSelection = this.monthsOptions;
            break;
          case "2":
            // Selected by Day
            this.demonstrativeFilterOptions = this.daysOptions;
            this.demonstrativeFilterSelection = this.daysOptions;
            break;
          case "3":
            // Selected by Modality
            this.demonstrativeFilterOptions = this.modalitiesOptions;
            this.demonstrativeFilterSelection = this.modalitiesOptions;
            break;
          case "4":
            // Selected by Category
            this.demonstrativeFilterOptions = this.categoriesOptions;
            this.demonstrativeFilterSelection = this.categoriesOptions;
            break;
          case "5":
            // Selected by System
            this.demonstrativeFilterOptions = this.systemOptions;
            this.demonstrativeFilterSelection = this.systemOptions;
            break;
          case "6":
            // Selected by Equipment
            this.demonstrativeFilterOptions = this.equipmentOptions;
            this.demonstrativeFilterSelection = [];
            break;
          case "7":
            // Selected by Entity
            this.demonstrativeFilterOptions = this.entitiesOptions;
            this.demonstrativeFilterSelection = this.entitiesOptions;
            break;
          default:
            // code block
            this.demonstrativeFilterOptions = [];
            this.demonstrativeFilterSelection = [];
        }
        this.demonstrativeSelectionOld = this.demonstrativeSelection;
      }
      this.checkStratificationSelection();
    },
    checkStratificationSelection: function () {
      if (this.stratificationSelection != this.stratificationSelectionOld) {

        switch (this.stratificationSelection) {
          case "3":
            // Selected by Modality
            this.stratificationFilterOptions = this.modalitiesOptions;
            this.stratificationFilterSelection = this.modalitiesOptions;
            break;
          case "4":
            // Selected by Category
            this.stratificationFilterOptions = this.categoriesOptions;
            this.stratificationFilterSelection = this.categoriesOptions;
            break;
          case "5":
            // Selected by System
            this.stratificationFilterOptions = this.systemOptions;
            this.stratificationFilterSelection = this.systemOptions;
            break;
          case "6":
            // Selected by Equipment
            this.stratificationFilterOptions = this.equipmentOptions;
            this.stratificationFilterSelection = [];
            break;
          default:
            // code block
            this.stratificationFilterOptions = [];
            this.stratificationFilterSelection = [];
        }
        this.stratificationSelectionOld = this.stratificationSelection;
      }
    },
    checkTicketList: function () {
      // console.log(this.ticketExportList.length)
      if (
        this.searchingTickets == true &&
        this.ticketList.length == this.totalTicketLists &&
        this.totalTicketLists != 0 &&
        this.ticketList.length > 0
      ) {
        this.printPDF(0);

        this.searchingTickets = false;
      }

      if (
        this.searchingTickets == true &&
        this.tickets.length == this.totalTickets &&
        this.totalTickets != 0 &&
        this.techList.length > 0
      ) {
        // console.log("List Complete!")

        this.loading = true;

        var swapYears = [],
          swapMonths = [],
          swapDays = [],
          swapEntities = [],
          swapModalities = [],
          swapCategories = [],
          swapSystems = [],
          swapEquipments = [];
        var convertStatus = this.user.convertStatus;
        var convertPriority = this.user.convertPriority;
        var convertModality = this.user.convertModality;
        var convertMonth = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
        ];
        for (var j = 0; j < this.tickets.length; j++) {
          this.tickets[j].status = convertStatus[this.tickets[j].status];
          this.tickets[j].priority = convertPriority[this.tickets[j].priority];
          this.tickets[j].modality = convertModality[this.tickets[j].modality];
          this.tickets[j].description = this.strip(this.tickets[j].description)
            .replace(/(<([^>]+)>)/gi, "")
            .replace("\n", " | ");
          this.tickets[j].solution = this.strip(this.tickets[j].solution)
            .replace(/(<([^>]+)>)/gi, "")
            .replace("\n", " | ");

          var date = new Date(this.tickets[j].date);

          this.tickets[j].year = date.getFullYear();
          this.tickets[j].month =
            date.getFullYear() + "/" + convertMonth[date.getMonth()];
          if (date.getDate() < 10) {
            this.tickets[j].day =
              date.getFullYear() +
              "/" +
              convertMonth[date.getMonth()] +
              "/0" +
              date.getDate();
          } else {
            this.tickets[j].day =
              date.getFullYear() +
              "/" +
              convertMonth[date.getMonth()] +
              "/" +
              date.getDate();
          }

          swapYears.push(this.tickets[j].year);
          swapMonths.push(this.tickets[j].month);
          swapDays.push(this.tickets[j].day);
          swapModalities.push(this.tickets[j].modality);
          swapEntities.push(this.tickets[j].entity);
          if (this.tickets[j].category) {
            if (this.tickets[j].category.search(" > ") > 0) {
              swapCategories.push(
                this.tickets[j].category.substring(
                  0,
                  this.tickets[j].category.search(" > "),
                ),
              );
              this.tickets[j].categorySimple = this.tickets[
                j
              ].category.substring(0, this.tickets[j].category.search(" > "));
            } else {
              swapCategories.push(this.tickets[j].category);
            }
          }

          for (var k = 0; k < this.equipments.length; k++) {
            if (
              this.tickets[j].equipment == this.equipments[k].glpiid &&
              this.tickets[j].equipment_type == this.equipments[k].itemtype
            ) {
              this.tickets[j].equipment = this.equipments[k].name;
              swapEquipments.push(this.tickets[j].equipment);
            }
          }

          for (var k = 0; k < this.user.equipmentModels.length; k++) {
            if (
              this.tickets[j].equipment_type ==
              this.user.equipmentModels[k].itemtype
            ) {
              this.tickets[j].equipment_type =
                this.user.equipmentModels[k].name;
              swapSystems.push(this.tickets[j].equipment_type);
            }
          }

          if (this.tickets[j].hours != null) {
            if (Array.isArray(this.tickets[j].hours)) {
              var swap = 0;
              for (var k = 0; k < this.tickets[j].hours.length; k++) {
                swap = swap + parseInt(this.tickets[j].hours[k]);
                // console.log(swap)
              }
              this.tickets[j].hours = Math.round(swap / 3600);
            } else {
              this.tickets[j].hours = Math.round(
                parseInt(this.tickets[j].hours) / 3600,
              );
            }
          }
          // change users if only one
          for (var i = 0; i < this.techList.length; i++) {
            // change user req
            if (
              !Array.isArray(this.tickets[j].user_req) &&
              this.techList[i].id == this.tickets[j].user_req
            ) {
              this.tickets[j].user_req = this.techList[i].name;
            }

            // change user tech
            if (
              !Array.isArray(this.tickets[j].user_tech) &&
              this.techList[i].id == this.tickets[j].user_tech
            ) {
              this.tickets[j].user_tech = this.techList[i].name;
            }

            // change user act tech
            if (
              !Array.isArray(this.tickets[j].act_tech) &&
              this.techList[i].id == this.tickets[j].act_tech
            ) {
              this.tickets[j].act_tech = this.techList[i].name;
            }
          }

          // change users if array

          if (Array.isArray(this.tickets[j].user_req)) {
            var swap = "";
            for (var k = 0; k < this.tickets[j].user_req.length; k++) {
              for (var i = 0; i < this.techList.length; i++) {
                if (this.techList[i].id == this.tickets[j].user_req[k]) {
                  if (swap != "") {
                    swap = swap + " , ";
                  }
                  swap = swap + this.techList[i].name;
                }
              }
            }
            this.tickets[j].user_req = swap;
          }

          if (Array.isArray(this.tickets[j].user_tech)) {
            var swap = "";
            for (var k = 0; k < this.tickets[j].user_tech.length; k++) {
              for (var i = 0; i < this.techList.length; i++) {
                if (this.techList[i].id == this.tickets[j].user_tech[k]) {
                  if (swap != "") {
                    swap = swap + " , ";
                  }
                  swap = swap + this.techList[i].name;
                }
              }
            }
            this.tickets[j].user_tech = swap;
          }

          if (Array.isArray(this.tickets[j].act_tech)) {
            var swap = "";
            for (var k = 0; k < this.tickets[j].act_tech.length; k++) {
              for (var i = 0; i < this.techList.length; i++) {
                if (this.techList[i].id == this.tickets[j].act_tech[k]) {
                  if (swap != "") {
                    swap = swap + " , ";
                  }
                  swap = swap + this.techList[i].name;
                }
              }
            }
            this.tickets[j].act_tech = swap;
          }
        }

        // console.log(swapEquipments)
        this.yearsOptions = this.listFormatada([...new Set(swapYears.sort())]);
        this.monthsOptions = this.listFormatada([
          ...new Set(swapMonths.sort()),
        ]);
        this.daysOptions = this.listFormatada([...new Set(swapDays.sort())]);
        this.modalitiesOptions = this.listFormatada([
          ...new Set(swapModalities.sort()),
        ]);
        this.categoriesOptions = this.listFormatada([
          ...new Set(swapCategories.sort()),
        ]);
        this.systemOptions = this.listFormatada([
          ...new Set(swapSystems.sort()),
        ]);
        this.equipmentOptions = this.listFormatada([
          ...new Set(swapEquipments.sort()),
        ]);
        this.entitiesOptions = this.listFormatada([
          ...new Set(swapEntities.sort()),
        ]);

        this.searchingTickets = false;
        this.showFilters = true;
        this.loading = false;

        // console.log(this.tickets)
      }
    },
  },
};
</script>

<style>
.apexcharts-menu-item.exportSVG {
  display: none;
}

.apexcharts-menu-item.exportPNG {
  display: none;
}
</style>
